import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAction } from '@reduxjs/toolkit';
import { compareIdsSelector, dataSelector, favoriteIdsSelector } from "../selectors/deviceSelectors";
import { DeviceServices } from "../services/DeviceServices";
import { devicesModel } from "../model/devicesModel";
import { DEVICE_KEY, DEVICE_TYPE } from "../constant";
import { ymPushParams } from "../../../utils/analytics/ym";
import { sentYMEventHover } from "../components/ActionButtons/utils/ym";
export var setDevicesInitialState = createAction('set devices initial state');
export var setDevices = createAction('set devices');
export var setIds = createAction('set ids');
export var deleteCompareDevice = createAction('delete compare device');
export var deleteFavoriteDevice = createAction('delete favorite device');
export var addCompareDevice = createAction('add compare device');
export var addFavoriteDevice = createAction('add favorite device');
export var deleteDeviceAction = function deleteDeviceAction(_ref) {
  var type = _ref.type,
    data = _ref.data;
  return function (dispatch) {
    dispatch(setIds({
      type: type,
      data: data
    }));
    if (type === DEVICE_KEY.FAVORITE_DEVICES) {
      dispatch(deleteFavoriteDevice({
        data: data
      }));
    }
    if (type === DEVICE_KEY.COMPARISON_DEVICES) {
      dispatch(deleteCompareDevice({
        data: data
      }));
    }
  };
};
var getPrepareData = function getPrepareData(type, ids, actionIds) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var data, prepareData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return DeviceServices.getProductsList(ids);
          case 2:
            data = _context.sent;
            prepareData = data.map(function (device, index) {
              return devicesModel.fromAPI(device, actionIds, index);
            });
            dispatch(setDevices({
              data: prepareData,
              type: DEVICE_KEY[type]
            }));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getDeviceList = function getDeviceList(type) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var state, favoriteIds, compareIds;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();
            favoriteIds = favoriteIdsSelector(state);
            compareIds = compareIdsSelector(state);
            if (favoriteIds !== null && favoriteIds !== void 0 && favoriteIds.length && type === DEVICE_TYPE.favorite) {
              dispatch(getPrepareData(type, favoriteIds, compareIds));
            }
            if (compareIds !== null && compareIds !== void 0 && compareIds.length && type === DEVICE_TYPE.compare) {
              dispatch(getPrepareData(type, compareIds, favoriteIds));
            }
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var addDeviceAction = function addDeviceAction(_ref4) {
  var type = _ref4.type,
    data = _ref4.data;
  return function (dispatch) {
    dispatch(setIds({
      type: type,
      data: data
    }));
    if (type === DEVICE_KEY.FAVORITE_DEVICES) {
      dispatch(addFavoriteDevice({
        data: data
      }));
    }
    if (type === DEVICE_KEY.COMPARISON_DEVICES) {
      dispatch(addCompareDevice({
        data: data
      }));
    }
    dispatch(getDeviceList(DEVICE_TYPE[type]));
  };
};
export var addCustomEventAction = function addCustomEventAction(type, count) {
  return function (dispatch) {
    dispatch(getDeviceList(type));
    var handleDeviceEvent = function handleDeviceEvent(actionType) {
      return function (_ref5) {
        var detail = _ref5.detail;
        var action = {
          data: detail || [],
          type: actionType
        };
        if ((detail === null || detail === void 0 ? void 0 : detail.length) < count) {
          dispatch(deleteDeviceAction(action));
        } else dispatch(addDeviceAction(action));
      };
    };
    if (typeof document !== 'undefined') {
      document.body.addEventListener(type, handleDeviceEvent(DEVICE_KEY[type]));
    }
  };
};
export var sentYMEventAction = function sentYMEventAction(_ref6) {
  var type = _ref6.type;
  return function (dispatch, getState) {
    var state = getState();
    var data = dataSelector(state, DEVICE_KEY[type]);
    if (data.length) {
      ymPushParams(sentYMEventHover({
        data: data,
        type: type,
        action: 'view',
        event: 'hover'
      }));
    }
  };
};